import React from "react";
import cx from "classnames";

export function Loader({large}) {
  return (
    <div className={cx("admin-lds-ring", {"admin-lds-ring--large": large})}><div /><div /><div /><div /></div>
  );
}
